import { render } from "./NavigationOrganizationItem.vue?vue&type=template&id=c5f6220c&scoped=true"
import script from "./NavigationOrganizationItem.vue?vue&type=script&lang=js"
export * from "./NavigationOrganizationItem.vue?vue&type=script&lang=js"

import "./NavigationOrganizationItem.vue?vue&type=style&index=0&id=c5f6220c&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5f6220c"]])

export default __exports__